import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getError, getNotifications } from './notification-data.reducer';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { Notification } from './notification.model';
import { filter } from 'rxjs/operators';

@Injectable()
export class NotificationDataStore {
  notifications$ = this._store.select(getNotifications);

  constructor(private _store: Store<any>) {}

  getNotifications(): Observable<List<Notification>> {
    return this.notifications$.pipe(filter((x) => !!x));
  }

  getError(): Observable<Error> {
    return this._store.select(getError);
  }
}
